export const defaultUserAccess: IUserTypeAccess = {
	projects: false,
	ovrigaProduckter: false,
	WaterDrainage: false,
	infästning: false,
	taksäkerhet: false,
	poiA: false,
	checkoutOptions: false,
	productA: false,
	productB: false,
	userAccess: {
		canAddEditProject: false,
		canInviteOtherUserToProject: false,
		canAddPothosDoc: false,
		canSeeProductPrice: false,
		canEditUserAccess: false,
		canCreateNotesInProject: false,
	}
}

/**
 * Computes user type access flags based on the user's type (A/B/C/D).
 * Pure function — no side effects.
 */
export function computeUserTypeAccess(userType: string | undefined): IUserTypeAccess {
	if (!userType) {
		return { ...defaultUserAccess };
	}

	const type = userType.toLocaleLowerCase();

	if (type === "a") {
		return {
			projects: true,
			ovrigaProduckter: true,
			WaterDrainage: true,
			infästning: true,
			taksäkerhet: true,
			poiA: true,
			checkoutOptions: true,
			productA: true,
			productB: true,
			userAccess: {
				canAddEditProject: true,
				canInviteOtherUserToProject: true,
				canAddPothosDoc: true,
				canSeeProductPrice: false,
				canEditUserAccess: true,
				canCreateNotesInProject: true,
			}
		};
	}

	if (type === "b") {
		return {
			projects: true,
			ovrigaProduckter: true,
			WaterDrainage: true,
			infästning: true,
			taksäkerhet: true,
			poiA: true,
			checkoutOptions: true,
			productA: true,
			productB: true,
			userAccess: {
				canAddEditProject: false,
				canInviteOtherUserToProject: false,
				canAddPothosDoc: true,
				canSeeProductPrice: false,
				canEditUserAccess: false,
				canCreateNotesInProject: true,
			}
		};
	}

	if (type === "c") {
		return {
			...defaultUserAccess,
			productA: true,
			ovrigaProduckter: true,
			poiA: true,
		};
	}

	if (type === "d") {
		return {
			...defaultUserAccess,
			productA: true,
			ovrigaProduckter: true,
			userAccess: {
				...defaultUserAccess.userAccess,
				canSeeProductPrice: true,
			}
		};
	}

	return { ...defaultUserAccess };
}
